import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';
import { localization } from '../../../shared/localization/localization';
import { PdfIcon } from 'src/App/shared/icons/pt-icon-pdf';
import { ConfirmSendIcon } from 'src/App/shared/icons/pt-icon-confirm-send';
import { SaveIcon } from 'src/App/shared/icons/pt-icon-save';

export interface ILogoEditorPreviewControlsProps {
    onSaveClick(): void;
    onContinueClick(): void;
}

export class LogoEditorPreviewControls extends React.Component<ILogoEditorPreviewControlsProps> {
    constructor(props: ILogoEditorPreviewControlsProps) {
        super(props);
    }

    public render() {
        return (
            <div className="editor-preview-controls">                
                <div className="editor-preview-btn">
                    <button className="accent-style"
                        data-tip={true} data-for='create-pdf-tip'
                        onClick={() => this.props.onContinueClick()}>
                        <div className="icon-btn-content accent-icon">                            
                            <div className="icon-content">
                                <ConfirmSendIcon />
                            </div>
                            <div className="text-content">
                                <span>{localization.editorLoc.logoEditorContent.continueButton}</span>
                            </div>
                        </div>
                    </button>
                    <ReactTooltip id="create-pdf-tip" effect={'solid'} place={'top'}>
                        <div style={{maxWidth: 200}}>{localization.editorLoc.logoEditorContent.toolTips.continue}</div>                    
                    </ReactTooltip>
                </div>
                <div className="editor-preview-btn">
                    <button className="primary-style"
                        data-tip={true} data-for='save-motive-tip'
                        onClick={() => this.props.onSaveClick()}>
                        <div className="icon-btn-content primary-icon">
                            <div className="icon-content">
                                <SaveIcon />
                            </div>
                            <div className="text-content">
                                <span>{localization.editorLoc.logoEditorContent.saveToGalleryButton}</span>
                            </div>
                        </div>
                    </button>
                    <ReactTooltip id="save-motive-tip" effect={'solid'} place={'top'}  >
                        <div style={{maxWidth: 200}}>{localization.editorLoc.logoEditorContent.toolTips.saveMotive}</div>   
                    </ReactTooltip>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-preview-controls.component.tsx